import { render, staticRenderFns } from "./NotaParticipante.vue?vue&type=template&id=848f6298&"
import script from "./NotaParticipante.vue?vue&type=script&lang=js&"
export * from "./NotaParticipante.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports